import { RootState } from 'ReduxConfig/store';

export const selector = ({ users }: RootState) => ({
  pending: users.status === 'pending',
  error: users.error?.message,
  user: users.user
});
